import { QUERY_KEYS } from '@/hooks/react-query/constants'
import { __cCareShareService } from '@/services/client/__c.care-and-share.service'
import { useQuery } from '@tanstack/react-query'

export const useCareAndShareConfigs = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.CARE_AND_SHARE_CONFIGS],
    queryFn: __cCareShareService.getCareAndShareConfigs,
  })
}
